export default __webpack_public_path__ + "static/media/kimdu.0fd7c6e6.png";